import {catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ExceptionService, PaginatedList, UtilsService } from '../../../xform-compat';
import { RmsBasicCrudService } from '../../components/rms-basic-crud.service';
import { Attachment, CompanyAttachments } from '../../../shared/models';

@Injectable({
  providedIn: 'root'
})
export class CompanyAttachmentsService extends RmsBasicCrudService<any> {

  constructor(
    http: HttpClient,
    utilsService: UtilsService,
    exceptionService: ExceptionService
  ) {
    super(http, utilsService, exceptionService);
  }

  /**
   * Gets the list of attachments for an space
   * @param {number} spaceId
   * @param {number} crmIds
   * @param {number} pagesize
   * @param page
   * @returns {Observable<PaginatedList<CompanyAttachments>>}
   */
  public getAttachmentsList (spaceId: number, crmIds: Array<number>, pagesize: number, page = 0): Observable<PaginatedList<Attachment>> {
    const params: object = {
      'extrafield': 'createdBy',
      'pagesize': String(pagesize),
      'page': String(page),
      'sort': 'created',
      'direction': 'DESC'
    };

    if (crmIds !== null) {
      params['crmids'] = crmIds;
    }
    return super.getData(`/api/rms/spaces/${spaceId}/attachments`, params);
  }

  /**
   * Downloads an attachment
   * @param {CompanyAttachments} item
   * @returns {Observable<Blob>}
   */
  public downloadFile (item: CompanyAttachments | Attachment): Observable<Blob> {
    const headers = new HttpHeaders({'Accept': 'application/octet-stream'});
    return super
      .getHttp()
      .get(`/api/rms/attachments/${item.id}`, {headers, responseType: 'blob'}).pipe(
      catchError(ex => super.getExceptions().catchBadResponse(ex)));
  }

  /**
   * Uploads a file to the server
   * @param fileToUpload
   */
  public uploadFile (fileToUpload: File): Observable<Attachment> {
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    return super.saveData('/api/rms/attachments', formData);
  }

}
